import {del} from '../utils'

export default host => (id, photoId) =>
  del(`${host}/people/${id}/image/${photoId}`)
    .then(response => response.json())
